
export default class RemoteValidator {

    validationService = null

    constructor (validationService) {
        this.validationService = validationService
    }

    validate(ruleId, request) {
        switch (ruleId) {
            case "phone":
                return this.validationService.validatePhoneNumber(request.phoneNumber)
            case "zipCodeState":
                return this.validationService.validateZipCodeState(request.zipCode, request.state)
            case "email":
                return this.validationService.validateEmail(request.email)
            default:
                return Promise.resolve({ valid: true })
        }


    }

}
